import type { Artifact } from '../../../../bridge/types/artifact.ts';
import type { EmailStep } from '../../../../bridge/types/setup-steps.ts';

export const TYPE_TITLES: Record<string, string> = {
	instagram_post: 'Instagram Post',
	digital_ad: 'Review Digital Ad',
	instagram_dm: 'Review Instagram DM',
	instagram_comment_reply: 'Review Comment Replies',
	email_plaintext: 'Review Email',
	email_html: 'Review Email',
	ig_comment_watcher_class: 'Review Comment Watcher',
	subreddit_monitor: 'Monitor Subreddits',
	custom_monitor: 'Monitor',
	deferred_content: 'Review Deferred Content',
	request_owner_action: 'Your part',
	inspiration_reference: 'Saved Inspiration',
};

export const TYPE_TAGS: Record<string, string> = {
	instagram_post: 'Instagram Post',
	digital_ad: 'Digital Ad',
	instagram_dm: 'Instagram DM',
	instagram_comment_reply: 'Comment Replies',
	email_plaintext: 'Email',
	email_html: 'Email',
	ig_comment_watcher_class: 'Comment Watcher',
	subreddit_monitor: 'Monitor Subreddits',
	custom_monitor: 'Job',
	deferred_content: 'Deferred Content',
	request_owner_action: 'Your part',
	inspiration_reference: 'Saved Inspiration',
};

export const EMAIL_STEP_COPY = {
	EmailTemplateSelection: {
		title: 'Select Email Template',
		description:
			'Choose the template variant you want to personalize for this campaign',
	},
	EmailGenerating: {
		title: 'Writing your email',
		description: 'Filling the template with your brand voice and brief.',
	},
	EmailPersonalization: {
		title: 'Personalize Email',
		description:
			'Edit your subject line and body content to match the message you want to send',
	},
	EmailRecipients: {
		title: 'Set Recipients',
		description:
			'Upload a .csv file, add contacts manually, or select from your audiences.',
	},
} as const;

export const EMAIL_GENERATING_STATUS_LINES = [
	'Reading your brand voice',
	'Reviewing your recent posts',
	'Pulling in your business details',
	'Studying your audience',
	'Mapping the template structure',
	'Sketching the opening line',
	'Drafting the subject line',
	'Trying a few subject variations',
	'Picking the strongest hook',
	'Writing the intro paragraph',
	'Filling in the template',
	'Working on the main message',
	'Tightening the body copy',
	'Adding your unique voice',
	'Choosing supporting details',
	'Polishing the call to action',
	'Fitting the button text',
	'Aligning the layout',
	'Selecting accent colors',
	'Setting image placeholders',
	'Trimming filler words',
	'Checking the reading flow',
	'Running a tone pass',
	'Smoothing the transitions',
	'Reviewing for clarity',
	'Personalizing the sign-off',
	'Double-checking the details',
	'Formatting for mobile',
	'Previewing the result',
	'Adding the finishing touches',
	'Almost there',
] as const;

export const EMAIL_GENERATING_TITLE = 'Generating Email';

export const EMAIL_STEP_TITLES: Record<EmailStep, string> = {
	EmailTemplateSelection: 'Select Template',
	EmailPersonalization: 'Edit Email',
};

export const getEmailPanelTitle = (
	currentStep: EmailStep | undefined,
	isGenerating: boolean,
): string => {
	if (isGenerating) return EMAIL_GENERATING_TITLE;
	if (currentStep && currentStep in EMAIL_STEP_TITLES) {
		return EMAIL_STEP_TITLES[currentStep];
	}
	return 'Edit Email';
};

export const ACTION_TYPE_TAGS: Record<string, string> = {
	send_email_to_contacts: 'Email Send',
	publish_instagram_post: 'Publish Post',
	publish_instagram_comment_reply: 'Publish Reply',
	monitor_instagram_comments_and_reply: 'Monitor Comments',
};

export function isArtifactActionable(artifact: Artifact): boolean {
	return artifact.status === 'draft';
}
